import { PREFERENCES_QUERY_KEYS } from '@frontends/util-preferences';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

const CONSUMED = Object.values(PREFERENCES_QUERY_KEYS);

export const AppearanceQueryCleanup = (): null => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (!CONSUMED.some((key) => searchParams.has(key))) {
      return;
    }

    const next = new URLSearchParams(searchParams);
    CONSUMED.forEach((key) => next.delete(key));

    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  return null;
};
